

	<!-- User Info Card -->

	<div class="col-12 col-md-12" style="height: 100%;">
		<div class="card h-100">
			<div class="card-body">
				<h5 class="card-title">{{contentStrings['Payments'][language]}}</h5>
				<div class="row g-1 mt-1">
					<!-- main rent view-->
					<div class="col-12 col-md-12">

						<div>
							<div style="font-size: 1.3em;font-weight: 500;text-transform: uppercase;">
								{{contentStrings['YourCurrentBalance'][language]}}
							</div>
							<div style=" font-size: 2em; font-weight: 600; color: #558dc1;">
								<!-- Display current balance here in yen-->
								{{ paymentsService.Current_balance()	 | currency:'JPY':'symbol':'1.0-0' }}
							</div>
						</div>

						<div style="display: flex;width: 100%;align-items: center; border-top: 1px solid #ffddbe;border-bottom: 1px solid #ffddbe;background: #f6f6f6;font-size: 1.2em;">
							<div style="padding: 20px;">
								<i class="fa-solid fa-circle-exclamation" style="font-size: 2em;color: #295a8e;"></i>
							</div>
							<div>
								<div>
									{{contentStrings['ScheduledPaymentMessage'][language]}}
								</div>
								<div>
								<div>
									{{contentStrings['PaymentDate'][language]}}
										{{ paymentsService.Next_Payment_Date() | date:'longDate':undefined:currentLocale }}
								</div>
									<div style="cursor: pointer; text-decoration: underline; font-size: .8em;text-transform: uppercase;font-weight: 600;color: #4d62a8;">
										<i class="fa-solid fa-asterisk"></i> {{contentStrings['ShowDetails'][language]}}
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<!-- two buttons, pay now and schedule payment-->
							<div class="col-6" style="padding: 6px;">
								<button class="btn btn-primary" style=" width:100%; font-size: 1.1em;">
									{{contentStrings['PayNow'][language]}}
								</button>
							</div>
							<div class="col-6" style="padding: 6px;">
								<button class="btn btn-secondary" style=" width:100%; font-size: 1.1em;">
									{{contentStrings['SchedulePayment'][language]}}
								</button>
							</div>
						</div>
						<div style="margin-top: 12px; font-size: .9em; color: #555;">
							{{contentStrings['ChangeScheduledPayment'][language]}}
							<a routerLink="/pay-my-rent" style="text-decoration: underline; cursor: pointer; color: #4d62a8;">
								{{contentStrings['ClickHereToChange'][language]}}
							</a>
						</div>
					</div>
					<div class="col-12 col-md-12">
						<div style="margin-top: 24px; font-size: 1.2em;font-weight: 500;text-transform: uppercase;">
							{{contentStrings['PastPayments'][language]}}
						</div>
						<div *ngFor="let payment of pastPayments()" style="display: flex; justify-content: space-between; padding: 8px 0px; border-bottom: 1px solid #eee;">
							<div>
								{{ payment.date | date:'longDate':undefined:currentLocale }}
							</div>
							<div style="font-weight: 600; color: #558dc1;">
								{{ payment.amount | currency:'JPY':'symbol':'1.0-0' }}
							</div>
						</div>
						<div style="margin-top: 12px; font-size: .9em; color: #555;">
							<a routerLink="/pay-my-rent" style="text-decoration: underline; cursor: pointer; color: #4d62a8;">
								{{contentStrings['GoToPaymentHistory'][language]}}
							</a>
						</div>

					</div>

				</div>
				<!--past payments view-->
				<div class="col-12 col-md-6">

				</div>
			</div>
		</div>
	</div>


